<template>
  <v-container class="pa-16">
    <v-data-table
      :headers="headers"
      :items="reports_types"
      class="elevation-0"
      no-data-text=""
      no-results-text=""
      :footer-props="{
        itemsPerPageOptions: [20, 30, 40, 50],
        showFirstLastPage: true,
        itemsPerPageText: 'Lignes par page :',
      }"
    >
      <template v-slot:body.prepend v-if="loader">
        <tr v-for="n in 5" :key="'skeleton-' + n">
          <td :colspan="headers.length + 1">
            <v-skeleton-loader type="table-row" class="mx-5 my-2" />
          </td>
        </tr>
      </template>
      <template v-slot:no-data v-if="!loader">
        Aucun type de rapport 
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title id="toolbar-title">Types de rapports </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="870px">
            <template v-slot:activator="{ on, attrs }">
              <Button
                v-bind="attrs"
                v-on="on"
                class="mb-2"
                action_name="Ajouter"
                color="primary"
                text
                @clicked="openAddDialog"
              />
            </template>
            <v-card>
              <v-card-title class="justify-space-between">
                <span class="headline">{{ formTitle }}</span>
                <v-btn color="black" dark icon right @click="close">
                  <v-icon color="#B2BBAB">mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-form ref="form" style="width: 100%" v-model="isValid">
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <text-input
                          v-model="editedItem.name"
                          label="Type de rapport*"
                          id="name"
                          :rules="requiredRules"
                        />
                      </v-col>
                      <v-col cols="12" md="12">
                        <ckeditor
                          class="custom-ck-editor"
                          @ready="onReady"
                          :editor="editor"
                          v-model="editedItem.template"
                          :config="editorConfig"
                          @input="onEditorInput"
                        ></ckeditor>
                        <div v-if="ckeditorError" class="text-sm mt-1" style="color: red;">
                          {{ ckeditorError }}
                        </div>
                      </v-col>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="btn-actions">
                <Button
                  action_name="Continuer"
                  color="#86CC26"
                  @clicked="save(true)"
                  v-if="!showEditButton"
                  :loading="loading"
                />
                <Button
                  action_name="Ajouter"
                  color="#11887E"
                  text
                  @clicked="save(false)"
                  v-if="!showEditButton"
                  :loading="loadingAdd"
                />
                <Button
                  action_name="Modifier"
                  color="#11887E"
                  text
                  @clicked="update(false)"
                  v-if="showEditButton"
                  :loading="loadingEdit"
                />
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Etes vous sûr de supprimer ce type de rapport ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="dark darken-1" text @click="dialogDelete = false"
                  >Cancel</v-btn
                >
                <v-btn
                  color="secondary darken-1"
                  text
                  @click="deleteLine"
                  :loading="loadingDelete"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" small @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon class="mr-2" small @click="downloadItem(item)">mdi-download</v-icon>
        <v-icon class="mr-2" small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document"
import { Button, TextInput } from "@/components/base"
import {
  addTemplate,
  deleteTemplate,
  getAllTemplatesPaginated,
  updateTemplate,
  exportTypeReport
} from "@/services/reportsTypes"
export default {
  components: { Button, TextInput },
  data: () => ({
    dialogDelete: false,
    editor: DecoupledEditor,
    editorConfig: {
      toolbar: {
        removeItems: ["uploadImage", "mediaEmbed"],
        shouldNotGroupWhenFull: true
      }
    },
    loading: false,
    loadingAdd: false,
    loadingEdit: false,
    isValid: true,
    showEditButton: false,
    dialog: false,
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "id"
      },
      { text: "Nom", value: "name" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    reports_types: [],
    editedIndex: -1,
    editedItem: {
      template: ""
    },
    defaultItem: {},
    pageNumber: 1,
    last_page: 0,
    loadingDelete: false,
    ckeditorError: "",
    editorTouched: false,
    loader: false,
    options: {
      page: 1,
      itemsPerPage: 20
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nouveau type de rapport"
        : "Modifier type de rapport"
    }
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    downloadItem(item){
      exportTypeReport(item.id).then((response)=>{
        const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", `Type_rapport_${item.id}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      })
    },
    onEditorInput(value) {
      this.editedItem.template = value
      if (this.editorTouched) {
        this.validateEditor()
      }
    },

    validateEditor() {
      const rule = this.requiredRules[0]
      const result = rule(this.editedItem.template.trim()) || "Le contenu ne peut pas être vide."
      this.ckeditorError = result === true ? '' : result
      return this.ckeditorError === ''
    },

    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        )
    },
    deleteLine() {
      deleteTemplate(this.editedItem.id).then((response) => {
        this.reports_types = response.data.data
        this.last_page = response.data.last_page
        this.dialogDelete = false
      })
    },
    deleteItem(item) {
      this.dialogDelete = true
      this.editedItem = item
    },
    openAddDialog() {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.dialog = true
    },
    initialize() {
      const perPage = parseInt(this.options.itemsPerPage) || 20;
      this.loader = true;
      getAllTemplatesPaginated(this.pageNumber, perPage).then((response) => {
        this.reports_types = response.data.data
        this.last_page = response.data.last_page
        this.total = response.data.total
        this.loader = false
      })
    },
    close() {
      this.dialog = false
      this.ckeditorError = "";
      this.editorTouched = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
        this.showEditButton = false
      })
    },
    update() {
      this.loadingEdit = true
      updateTemplate(this.editedItem).then(() => {
        this.loadingEdit = false
        this.showEditButton = false
        this.$set(
          this.reports_types,
          this.editedIndex,
          { ...this.reports_types[this.editedIndex], ...this.editedItem }
        )
        this.close()
        this.$swal.fire({ title: "Type de rapport modifier avec succès" })
      })
    },
    editItem(item) {
      this.showEditButton = true
      this.editedIndex = this.reports_types.indexOf(item)
      this.editedItem = { ...item }
      this.dialog = true
    },
    save(dialogStat) {
      this.editorTouched = true;
      const isEditorValidNow = this.validateEditor();
      if (!this.isValid || !isEditorValidNow) {
        this.$refs.form.validate();
        return;
      }
      dialogStat ? (this.loading = true) : (this.loadingAdd = true)
      addTemplate(this.editedItem).then((response) => {
        dialogStat ? (this.loading = false) : (this.loadingAdd = false)
        this.reports_types.push(response.data)
        this.close()
        this.$refs.form.reset()
        this.dialog = dialogStat
        this.$swal.fire({ title: "Type de rapport ajouté avec succès" })
      })
    }
  }
}
</script>